// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: space-between;
  flex-direction: column;
  flex-wrap: wrap;
}

.button_container {
  display: flex;
  justify-content: space-between;
  margin: 32px;
}
.button_container button {
  width: 140px;
}

.drawing_manager__container {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.drawing_manager__row {
  display: flex;
  align-items: center;
  width: 800px;
  justify-content: space-evenly;
}
.drawing_manager__joystick {
  text-align: center;
}
.drawing_manager__button {
  margin: 8px;
  width: 80px;
  height: 50px;
}

.debug_buttons {
  margin-top: 70px;
}

.sign-block {
  position: relative;
  width: calc(100% - 60px);
  padding-bottom: calc((100% - 60px) * 0.2002820874);
  box-sizing: border-box;
  margin: 30px;
}
.sign-block > canvas {
  position: absolute;
  top: -3px;
  left: -3px;
  width: 100%;
  height: 100%;
  display: block;
  border: 3px solid gray;
  touch-action: none;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/tablet-sign/tablet-sign.component.scss"],"names":[],"mappings":"AAOA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;AANJ;;AAUA;EACI,aAAA;EACA,8BAAA;EACA,YAAA;AAPJ;AASI;EACI,YAAA;AAPR;;AAaI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAVR;AAaI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,6BAAA;AAXR;AAcI;EACI,kBAAA;AAZR;AAeI;EACI,WAAA;EACA,WAAA;EACA,YAAA;AAbR;;AAkBA;EACI,gBAAA;AAfJ;;AAmBA;EAGI,kBAAA;EACA,wBAAA;EACA,kDAAA;EACA,sBAAA;EACA,YANU;AAZd;AAoBI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AAlBR","sourcesContent":["@use \"sass:math\";\n\n$width: 709;\n$height: 142;\n$aspect: math.div($height, $width);\n\n// Контейнер\n.container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-content: space-between;\n    flex-direction: column;\n    flex-wrap: wrap;\n}\n\n//\n.button_container {\n    display: flex;\n    justify-content: space-between;\n    margin: 32px;\n    //\n    button {\n        width: 140px;\n    }\n}\n\n//\n.drawing_manager {\n    &__container {\n        width: 100%;\n        display: flex;\n        align-items: flex-start;\n        justify-content: center;\n    }\n    //\n    &__row {\n        display: flex;\n        align-items: center;\n        width: 800px;\n        justify-content: space-evenly;\n    }\n    //\n    &__joystick {\n        text-align: center;\n    }\n    //\n    &__button {\n        margin: 8px;\n        width: 80px;\n        height: 50px;\n    }\n}\n\n// Тестовая кнопка\n.debug_buttons {\n    margin-top: 70px;\n}\n\n// Контейнер для подписи\n.sign-block {\n    $spacing: 30px;\n    // Свойства\n    position: relative;\n    width: calc(100% - #{$spacing * 2});\n    padding-bottom: calc((100% - #{$spacing * 2}) * #{$aspect});\n    box-sizing: border-box;\n    margin: $spacing;\n    // Канвас\n    > canvas {\n        position: absolute;\n        top: -3px;\n        left: -3px;\n        width: 100%;\n        height: 100%;\n        display: block;\n        border: 3px solid gray;\n        touch-action: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
